export const drawArea = (state = null, action) => {
  switch (action.type) {
    case 'SET_DRAW_AREA': {
      const { data } = action.payload;
      return data;
    }
    case 'CLEAR_DRAW_AREA':
      return null;
    default:
      return state;
  }
};
